import { RootState } from "../reducers";

export const getThemeName = ({ theme: { themeName } }: RootState) => themeName;
